import {renamePropertyOld, renamePropertyValue} from 'common/report/util/properties';

import {TopPathsNodeType} from './enums';

export class TopPathsFlowStep {
  public conversionRate: number;
  public event: string;
  public totalCount: number;
  public type: string;

  private mappedSegments: Array<{label: string; value: string}>;

  constructor({conversionRate = null, event = ``, segments = [], totalCount = 0, type = `EMPTY`} = {}) {
    this.conversionRate = conversionRate;
    this.event = event;
    this.segments = segments;
    this.totalCount = Number(totalCount);
    this.type = type;
  }

  getFormattedSegments() {
    return this.segments.map((segment) => `${segment.label}: ${segment.value}`);
  }

  get isEmpty() {
    return this.type === `EMPTY`;
  }

  get isAnchor() {
    return this.type === TopPathsNodeType.Anchor;
  }

  get segments() {
    return this.mappedSegments;
  }

  set segments(segments: Array<{label: string; value: string; values?: []}>) {
    this.mappedSegments = segments.map((segment) => ({
      label: renamePropertyOld(segment.label),
      value: renamePropertyValue(segment.value, segment.label),
    }));
  }
}
